export default __webpack_public_path__ + "fonts/iconfont.3d19bec95a18a3a0dd7564aa4a1489c8.woff2";